export default __webpack_public_path__ + "static/media/digital-assets.2da2052b.svg";